import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Button } from '@material-ui/core';
import { auth } from "../app/firebase";
import { useHistory } from "react-router-dom";
import { logout } from "../features/userSlice";
import { useDispatch } from "react-redux";
import { get_footermaster } from '../apis/matchmakingapi';

const SocialLinks = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [istoken, setisToken] = useState(false);
    console.log(localStorage.getItem('authToken'));

    useEffect(() => {
        if (localStorage.getItem('authToken') != null) {
            setisToken(true);
        } else {
            setisToken(false);
        }
    }, [localStorage.getItem('authToken')])

    const handlelogout = () => {
        // auth.signOut().then(() => {
        localStorage.clear();
        history.push("/login");
        window.location.reload();
        //   dispatch(logout());
        // });
    };

    const [footerData, setFooterData] = React.useState({});

    useEffect(() => {
        getdata();
    }, []);

    function getdata() {
        get_footermaster()
            .then((res) => {
                console.log("Fetched footer data:", res);
                if (Array.isArray(res) && res.length > 0) {
                    setFooterData(res[0]); // if your API returns an array
                }
            })
            .catch((err) => {
                console.error("Error fetching footer links", err);
            });
    }


    return (
        <div>
            {/* Facebook */}
            <IconButton style={{ cursor: 'pointer' }} href={footerData?.facebookLink || "#"} target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
            </IconButton>

            {/* Instagram */}
            <IconButton href={footerData?.instagramLink || "#"} target="_blank" rel="noopener noreferrer">
                <InstagramIcon />
            </IconButton>
            {/* Twitter */}
            <IconButton href={footerData?.twitterLink || "#"} target="_blank" rel="noopener noreferrer">
                <TwitterIcon />
            </IconButton>

            {/* Gmail */}
            <IconButton href={`mailto:${footerData?.emailOffice || ""}`}>
                <MailOutlineIcon />
            </IconButton>
            {istoken === true ?
                <Button onClick={handlelogout}>Logout</Button>
                :
                null
            }

        </div>
    );
};

export default SocialLinks;
